export const triggerClickEvent = ($element) => {
  const clickEvent = new window.MouseEvent('click');
  $element?.dispatchEvent(clickEvent);
};

export const triggerCustomEvent = ($element, eventName, eventInit = null) => {
  const customEvent = new window.CustomEvent(eventName, eventInit);
  $element?.dispatchEvent(customEvent);
};
